import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '@coin/shared/auth/data-access';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'auth-gms-angular-client',
  template: '',
  styles: [],
  standalone: false
})
export class AuthGmsClientCallbackComponent implements OnInit {
  private auth = inject(AuthService);

  ngOnInit() {
    this.auth.handleLoginCallback();
  }
}
